import type { UserModel } from '@trading/core'
import axios from '../axios'
import type { UserRepository } from '@trading/core/src/repositories/user/user.repository'

export class UserRepositoryAxios implements UserRepository {
  constructor(private apiClient = axios) {
  }

  async me() {
    return this.apiClient
      .get<{ data: UserModel }>('auth/me')
      .then((resp) => resp.data.data)
  }
}
